import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
    LIST,
    FAILURE,
    SUCCESS,
    REQUEST
} from '../../../../redux/ActionType';
import { ARCHIVED_JOB_APPLICATIONS } from '../../constants';
import * as services from '../../../services/JobApplications';

function* list({ payload }) {
    try {
        const params = payload.params
            ? payload.params
            : yield select(state => state.dataTables.dataTableState.archivedApplications.params);
        const response = yield call(services.getArchivedJobApplications, params);
        yield put({
            type: SUCCESS(LIST(ARCHIVED_JOB_APPLICATIONS)),
            payload: { ...response }
        });
    } catch (error) {
        yield put({ type: FAILURE(LIST(ARCHIVED_JOB_APPLICATIONS)), payload: error });
    }
}

export function* watchArchivedJobApplications() {
    yield takeLatest(REQUEST(LIST(ARCHIVED_JOB_APPLICATIONS)), list);
}
